import { render, staticRenderFns } from "./recognition.vue?vue&type=template&id=7823acd2&scoped=true"
import script from "./recognition.vue?vue&type=script&lang=js"
export * from "./recognition.vue?vue&type=script&lang=js"
import style0 from "./recognition.vue?vue&type=style&index=0&id=7823acd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823acd2",
  null
  
)

export default component.exports